import { VehicleType } from "../../DataStructures/Vehicle/VehicleType";

export class TypeRatio{
    type : VehicleType;
    ratio: number;

    constructor(type:VehicleType,ratio:number){
        this.type = type;
        this.ratio = ratio;
    }
}